"use client";

import { Coffee, Headphones, Music, Sparkles, SprayCan, Waves } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyLegacyWealthLegal() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const amenities = [{
    icon: Waves,
    title: "LEGACY ASSET SHIELDS",
    description: "Leveraging specific state statutes to ground your assets against creditors and external threats."
  }, {
    icon: Music,
    title: "LEGACY REVIEW PROTOCOL",
    description: "A precise, 95 point, technical review of your current holdings to identify and\xA0 reveal potential vulnerabilities."
  }, {
    icon: Coffee,
    title: "LEGACY ACCESS",
    description: "Direct access to counsel, who will provide timely and thorough\xA0 answers to your most basic questions.\xA0"
  }, {
    icon: Sparkles,
    title: "LEGACY FAMILY SAFEGUARDS",
    description: "Sophisticated planning that ensures your\xA0 family''s health, kids and pets are fully protected.\xA0"
  }];
  return <section data-section-id="2598" id="why-legacy-wealth-legal" className="bg-background text-foreground min-h-screen w-full">
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div className="relative w-full lg:w-1/2 h-[60vh] lg:h-auto lg:min-h-screen overflow-hidden">
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wealth_florida_estate.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wealth_florida_estate.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694902/img/legacy_wealth_florida_estate.png-wvc-sizes" alt="Modern architectural detail of a high-end Florida estate" loading="lazy" decoding="async" className="absolute inset-0 w-full h-full object-cover" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-1.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-2.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-2-e1781058168439.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-3.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-3-e1781058377426.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-4.jpg" src="https://legacywealthlegal.com/wp-content/uploads/2026/06/Upthestairs-5.jpg" />
          {}
          <div className="absolute inset-0 opacity-[0.05] pointer-events-none mix-blend-overlay" style={{
          backgroundImage: "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='2'/></filter><rect width='100%' height='100%' filter='url(%23n)' opacity='0.6'/></svg>\")"
        }} />
          {}
          <div className="absolute inset-x-0 top-0 h-40 pointer-events-none" style={{
          background: "linear-gradient(180deg, hsl(215 45% 10% / 0.85) 0%, hsl(215 45% 10% / 0) 100%)"
        }} />
          {}
          <div className="absolute inset-x-0 bottom-0 h-32 pointer-events-none lg:hidden" style={{
          background: "linear-gradient(0deg, hsl(215 45% 10% / 0.9) 0%, hsl(215 45% 10% / 0) 100%)"
        }} />

          {}
          <div className="absolute bottom-6 left-6 md:bottom-10 md:left-10 backdrop-blur-md border border-primary/20 px-4 py-2.5 rounded-md" style={{
          backgroundColor: "hsla(215, 45%, 10%, 0.08)"
        }}>
            <div className="flex items-center gap-3 font-mono text-xs tracking-[0.2em] uppercase">
              <span className="text-foreground/90">The Standard</span>
              <span className="w-px h-3 bg-primary/30" />
              <span className="text-primary"><br /></span>
            </div>
          </div>
        </div>

        {}
        <div ref={ref} className="w-full lg:w-1/2 px-6 py-16 sm:px-10 sm:py-20 lg:px-24 lg:py-24 flex flex-col justify-center" style={{
        backgroundColor: "hsl(215 45% 10%)"
      }}>
          <div className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
            {}
            <div className="font-mono text-xs tracking-[0.25em] uppercase mb-8 text-primary"><br /></div>

            {}
            <h2 className="font-default font-bold text-4xl sm:text-5xl lg:text-[5rem] leading-[0.95] tracking-tight mb-8 text-primary">
              Wealth
              <br />
              <span className="relative inline-block !text-[rgba(255,255,255,1)]">
                Security.
                
              </span>
            </h2>

            {}
            <p className="font-serif text-lg leading-relaxed max-w-xl mb-12 text-secondary-foreground">
              At Legacy Wealth Legal, we treat your estate as a private vault. We have curated a 
              suite of legal strategies designed to dissolve uncertainty and transform 
              complex wealth preservation into a seamless, authoritative experience.
            </p>

            {}
            <ul className="flex flex-col">
              {amenities.map((amenity, i) => {
              const Icon = amenity.icon;
              return <li data-index={i} key={amenity.title} className="flex items-start gap-6 py-8 border-b border-border/20 transition-all duration-700 !text-[rgba(255,255,255,1)]" style={{
                transitionDelay: `${i * 80}ms`
              }}>
                    {}
                    

                    {}
                    <div className="flex-1 min-w-0">
                      <h3 className="font-default font-semibold text-lg uppercase mb-1.5 text-secondary-foreground" style={{
                    letterSpacing: "0.08em"
                  }}>
                        {amenity.title}
                      </h3>
                      <p className="font-serif italic text-sm leading-relaxed text-secondary-foreground">
                        {amenity.description}
                      </p>
                    </div>
                  </li>;
            })}
            </ul>

            {}
            <div className="mt-14">
              <Button asChild variant="outline" size="lg" className="bg-transparent border border-primary/40 text-primary hover:bg-primary hover:text-primary-foreground hover:border-primary px-8 py-6 h-auto font-default font-medium tracking-[0.15em] uppercase text-xs transition-all duration-300 rounded-md">
                <Link to="/FirmStoryPage">
                  Explore Our Story →
                </Link>
              </Button>
            </div>
          </div>
        </div>
      </div>
    </section>;
}